import Immutable from 'immutable';
import React, {FC, useCallback, useMemo, useState} from 'react';

import {HandlerOf} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';

/*
 * Props.
 */

export interface WithUnpinnedActivityTrackingInjectedProps {
  unpinnedActivityIds: Array<number>;
  markActivityAsUnpinned: HandlerOf<number>;
}

export const withUnpinnedActivityTracking = <P extends WithUnpinnedActivityTrackingInjectedProps>(
  Component: React.ComponentType<P>,
): FC<Omit<P, keyof WithUnpinnedActivityTrackingInjectedProps>> =>
  function (props) {
    const [unpinnedActivityIdsSet, setUnpinnedActivityIdsSet] = useState(() => Immutable.Set<number>());
    const unpinnedActivityIds = useMemo(() => unpinnedActivityIdsSet.toArray(), [unpinnedActivityIdsSet]);

    const markActivityAsUnpinned = useCallback(
      (activityId: number) => {
        setUnpinnedActivityIdsSet((ids) => ids.add(activityId));
      },
      [setUnpinnedActivityIdsSet],
    );

    return (
      <Component
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...(props as P)}
        unpinnedActivityIds={unpinnedActivityIds}
        markActivityAsUnpinned={markActivityAsUnpinned}
      />
    );
  };
